import { Chain, EVM_CHAINS } from "chainConfigs";
import { copyToClipboard } from "utils";
import { useMemo } from "react";
import { useState } from "react";
import { crossChainConfigs } from "v2/components/CrossChainDeposit/hocs/withCrossChainDeposit";

const withExportPrivateKey = (Component: React.ComponentType<any>) => {
  return ({
    defaultChain = "ethereum",
    chains,
    isOpen,
    close,
    onCopySuccess,
    keys,
    ...props
  }: {
    defaultChain?: Chain;
    chains: Array<Chain>;
    isOpen: boolean;
    close: () => void;
    onCopySuccess?: () => void;
    keys: Record<string, string | null>;
  }) => {
    const [selectedChain, setSelectedChain] = useState<Chain>(defaultChain);

    const sortedConfigs = useMemo(() => {
      const config = chains
        // Map to cross chain config
        .map((chains) => {
          return crossChainConfigs[chains];
        })
        // Sort by default token type
        .sort((a, b) => {
          const isAMatch = a.id === defaultChain ? 1 : -1;
          const isBMatch = b.id === defaultChain ? 1 : -1;

          return isAMatch - isBMatch;
        });
      return config;
    }, [chains, defaultChain]);

    const handleCopy = () => {
      const key = EVM_CHAINS.includes(selectedChain) ? keys.ethereum! : keys[selectedChain]!;
      if (key !== undefined) {
        const success = copyToClipboard(key);
        if (success) {
          onCopySuccess?.();
        }
      }
    };

    return (
      <Component
        {...props}
        isOpen={isOpen}
        close={close}
        onCopySuccess={onCopySuccess}
        sortedConfigs={sortedConfigs}
        selectedChain={selectedChain}
        setSelectedChain={setSelectedChain}
        handleCopy={handleCopy}
        keys={keys}
      />
    );
  };
};

export default withExportPrivateKey;
